(() => {
  const header = document.querySelector('[data-opsin-header]');
  if (!header) return;

  // The drawer and backdrop are siblings of the header (see opsin-header.liquid
  // for why), so they are queried at document level, not inside the header.
  const openButton = header.querySelector('[data-opsin-menu-open]');
  const menu = document.querySelector('[data-opsin-mobile-menu]');
  const backdrop = document.querySelector('[data-opsin-menu-backdrop]');
  const closeButton = menu ? menu.querySelector('[data-opsin-menu-close]') : null;
  let previousFocus = null;

  if (!openButton || !menu) return;

  const focusable = () => Array.from(menu.querySelectorAll('a[href], button:not([disabled])'));

  const closeMenu = () => {
    menu.hidden = true;
    if (backdrop) backdrop.hidden = true;
    document.body.classList.remove('opsin-menu-open');
    openButton.setAttribute('aria-expanded', 'false');
    if (previousFocus) previousFocus.focus();
  };

  const openMenu = () => {
    previousFocus = document.activeElement;
    menu.hidden = false;
    if (backdrop) backdrop.hidden = false;
    document.body.classList.add('opsin-menu-open');
    openButton.setAttribute('aria-expanded', 'true');
    const items = focusable();
    if (items.length) items[0].focus();
  };

  openButton.addEventListener('click', openMenu);
  if (closeButton) closeButton.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (event) => {
    if (menu.hidden) return;
    if (event.key === 'Escape') closeMenu();
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* Big Game sticky-bar activation (2026-08-30): the Big Game section's own
   mobile sticky bar previously showed at page load. Apply the same rule as
   the standard PDP bar — hidden until the buy module has been seen AND
   scrolled past, hidden again when the shopper returns to it. Pairs with
   the .is-active gate in opsin-fixes.css. Fail-safe: without
   IntersectionObserver the bar never shows. */
(() => {
  const section = document.querySelector('.opsin-big-game');
  if (!section || !('IntersectionObserver' in window)) return;
  const stickyBar = section.querySelector('[data-opsin-sticky]');
  const buyModule = section.querySelector('.opsin-buy');
  if (!stickyBar || !buyModule) return;

  let seenBuy = false;
  let pastBuy = false;
  const io = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      seenBuy = true;
      pastBuy = false;
    } else if (seenBuy) {
      pastBuy = entry.boundingClientRect.bottom < 0;
    }
    stickyBar.classList.toggle('is-active', seenBuy && pastBuy);
  }, { threshold: 0 });
  io.observe(buyModule);
})();
